// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"2a667174","239":"064be305","622":"e4dc17e7","977":"296efc77"}[chunkId] + ".chunk.js";
};